up.Layer.OverlayWithTether = class OverlayWithTether extends up.Layer.Overlay {
    createElements() {
        if (!this.origin) {
            up.fail('Missing { origin } option');
        }
        this._tether = new up.Tether({
            anchor: this.origin,
            align: this.align,
            position: this.position
        });
        this.createElement(this._tether.parent);
        this.createContentElement(this.element);
    }
    onContentSet() {
        this._tether.start(this.element);
    }
    onElementsRemoved() {
        this._tether.stop();
    }
    sync() {
        if (!this.isAlive())
            return;
        if (up.fragment.isAlive(this.element) && this._tether.isAlive()) {
            this._tether.sync();
        }
        else {
            this.dismiss(':detached', {
                animation: false,
                preventable: false
            });
        }
    }
};
